<template>
		<div class="campaign-details-wrapper">
				<form action="#"
				      @submit.prevent="submitForm"
				      class="form width-100"
				      ref="form"
				>
						<div class="row">
								<div class="col-sm-12" v-if="showTitle">
										<h3 class="text-left text-normal">
												Details / Media
										</h3>
								</div>
								<div class="col-sm-12">
										<div class="text-left text-danger" v-if="errors.has('internalError')">
												There was an error processing your personal information. Please try again later.
										</div>
								</div>
						</div>

						

						<div class="section-body margin-bottom-50">
								<div class="margin-bottom-20" v-if="!isLoading">
										<div class="row hh-form-btn-wrapper">
												<div v-if="!editMode"  class="form-group col-sm-5">
														<button type="button" v-on:click="backAction"
														        class="btn hh-btn hh-btn-lg hh-btn-gray hh-form-btn" name="Go back">
																Go Back
														</button>
												</div>
												<div class="form-group col-sm-5">
														<button type="submit" :disabled="!isFormReady"
														        class="btn hh-btn hh-btn-lg hh-btn-blue hh-form-btn" name="Save changes">
																Save Changes
														</button>
												</div>
										</div>
								</div>

								<div class="row" v-if="showSkipButton && campaignData.creation_step >= formData.step">
										<div class="col-sm-12">
												<h4 class="hh-blue text-right hh-cta-title" @click="skipAction">
														Skip >
												</h4>
										</div>
								</div>
								<div class="row" v-if="showSaveAsDraft">
										<div class="col-md-12 text-center margin-bottom-20">
												<span class="save-as-draft hh-blue hh-cta-title" @click="saveAsDraftAction">Save as draft</span>
										</div>
								</div>
						</div>
				</form>
		</div>
</template>

<script>
	import {mapActions} from 'vuex'
	import InputLabel from '../form/elements/InputLabel'
	import TextEditor from '../form/elements/TextEditor'
	import MultipleImageUpload from '../form/MultipleImageUpload'
	import vSelect from 'vue-select'
	import constants from '../../config'
	import { scrollTo } from '../../utils/componentHelper'


	export default {
		name: 'CampaignDetails',

		components: {
			InputLabel,
			TextEditor,
			MultipleImageUpload,
			vSelect,
		},

		props: {
			campaignData: Object,
			campaignImages: Object,
			staticData: {
				states: Object,
			},
			showTitle: {
				type: Boolean,
				default: true,
			},
			showSaveAsDraft: {
				type: Boolean,
				default: true,
			},
			showSkipButton: {
				type: Boolean,
				default: true,
			},
			editMode: {
				type: Boolean,
				default: false,
			},
		},

		data: () => {
			return {
				loading: true,
				dataAnalysed: false,
				forceRecompute: 0,
				campaignSlug: null,
				componentsLoadingStatus: {
					MultipleImageUpload: true,
				},
				formData: {
					informationType: 'campaign-details',
					method: 'put',
					withFiles: false,
					step: 2,

					images: {
				type: Object,
				default: {},
			},
				},
			}
		},

		beforeMount() {
			this.campaignSlug = this.campaignData.slug
			this.loading = false
		},

		mounted() {
		},

		methods: {
			...mapActions('campaign', ['storeInformation', 'saveAsDraft']),

			cancelAction() {
				window.location = '/dashboard'
			},

			backAction() {
				this.$emit('navigateBack')
			},

			skipAction () {
				this.$emit('navigateNext')
			},

			componentLoading(componentName, value) {
				this.componentsLoadingStatus[componentName] = value
			},

		

			submitForm() {
				this.loading = true
				this.formData.campaignSlug = this.campaignSlug

				this.storeInformation(this.formData).then(() => {
					this.forceRecompute++
					this.loading = false
					if (this.status === 'success') {
						this.$emit('formSubmitted')
					} else {
						scrollTo(this.$refs['form'])
					}

				})
			},

			saveAsDraftAction() {
				this.loading = true

				this.saveAsDraft(this.campaignSlug).then(() => {
					this.forceRecompute++
					if (this.saveAsDraftData.status === 'success') {
						this.cancelAction()
					}
					this.loading = false
				})
			}
		},

		computed: {
			isDataFetched() {
				return !_.isEmpty(this.campaignData)
			},

			storeInformationData: {
				get() {
					return this.$store.getters['campaign/storeInformationData'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			status: {
				get() {
					return this.$store.getters['campaign/storeInformationStatus'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			errors: {
				get() {
					return this.$store.getters['campaign/storeInformationErrors'](this.campaignSlug, this.formData.informationType, this.forceRecompute)
				},
			},

			saveAsDraftData: {
				get() {
					return this.$store.getters['campaign/saveAsDraftData'](this.campaignSlug, this.forceRecompute)
				},
			},

			isLoading() {
				for (let component in this.componentsLoadingStatus) {
					if (this.componentsLoadingStatus[component]) {
						return true
					}
				}

				return this.loading
			},

			isFormReady() {
				return !this.loading
			},

			uploadCampaignImagesEndpoint() {
				return `${constants.BASE_URL}campaign/upload-image/${this.campaignSlug}`
			},
		},

		watch: {
			isLoading(to, from) {
				this.$emit('componentLoading', 'campaignComponent', to)
			}
		}
	}
</script>

<style scoped>

</style>
